import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

/**
 * Product funnel intelligence — served by api-main (not academy-api) because
 * the funnel table, invoices, pricing regions and the shared product catalogue
 * all live in its public schema. Ebooks today; courses and mentorships appear
 * here automatically once their pages fire the same public tracking call.
 */
const clean = (params = {}) => {
	const out = {}
	Object.keys(params).forEach(key => {
		const value = params[key]
		if (value !== null && value !== undefined && value !== '') out[key] = value
	})

	return out
}

export const analyticsFilters = () => Http.get('/admin/product-analytics/filters')
export const analyticsOverview = (params = {}) => Http.get(`/admin/product-analytics/overview${serialize(clean(params))}`)
export const analyticsGeo = (params = {}) => Http.get(`/admin/product-analytics/geo${serialize(clean(params))}`)
export const analyticsProducts = (params = {}) => Http.get(`/admin/product-analytics/products${serialize(clean(params))}`)
export const analyticsAttribution = (params = {}) => Http.get(`/admin/product-analytics/attribution${serialize(clean(params))}`)
export const analyticsSessions = (params = {}) => Http.get(`/admin/product-analytics/sessions${serialize(clean(params))}`)
export const analyticsAccess = (params = {}) => Http.get(`/admin/product-analytics/access${serialize(clean(params))}`)
